import React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import ProgressType from '../types/Progress'

function Progress(props) {
  const {
    indent,
    isFirst,
    isLast,
    progress: { value, label, tooltip, onClick, className },
  } = props

  return (
    <Tooltip
      title={tooltip}
      classes={{
        tooltip: 'pg-tooltip',
      }}>
      <div
        className={cn('pg', className, {
          'pg-first': isFirst,
          'pg-last': isLast,
          'pg-hide': !value,
        })}
        style={{
          left: `${indent}%`,
          width: `${value}%`,
        }}
        onClick={onClick}>
        {label}
      </div>
    </Tooltip>
  )
}

Progress.propTypes = {
  indent: PropTypes.number,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  progress: PropTypes.instanceOf(ProgressType),
}

export default Progress
